import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import {
    ArticleBodaccValidationProcessStatus,
    ArticleValidationProcessStatus,
    CATEGORY_BODACC,
    DossierArticleWithInvoice,
    useDossierProcesses,
} from '@europrocurement/l2d-modules';
import { Box } from '@mui/material';
import React from 'react';
import DossierArticleProcessStatus from '../DossierArticleProcessStatus/DossierArticleProcessStatus';

type DossierProcessesTabTitleProps = {
    dossier: DossierOpenSearch;
    category: {
        id: number;
        label: string;
        validatorTypeId: number;
        checked: boolean;
    };
    dossierArticles: DossierArticleWithInvoice[];
};
const DossierProcessesTabTitle: React.FunctionComponent<DossierProcessesTabTitleProps> = function ({
    dossier,
    category,
    dossierArticles,
}) {
    const { getArticleProcessesStatus, getArticleProcessesStatusLabel, findProcessByArticle } =
        useDossierProcesses();

    // Bodacc :
    const getArticleBodaccProcessesStatus = (
        articleIds: Array<number>,
    ): ArticleValidationProcessStatus => {
        if (!dossier) {
            return 'pending';
        }
        const statuses = articleIds.map((articleId) => {
            const process = findProcessByArticle(dossier, [category.validatorTypeId], articleId);
            if (process) {
                return process.statusCode as ArticleBodaccValidationProcessStatus;
            }
            return 'pending';
        });

        if (statuses.length === 0) {
            return 'pending';
        }

        // Bloqué (priorité 1)  3 = avis publié KO ,4 = rejet temporaire, 5 = annulé (double emploi)
        const isLocked = statuses.some((element) => ['3', '4', '5'].includes(element));
        if (isLocked) {
            return 'failed';
        }

        // À faire (priorité 2)
        const unSubmitted = statuses.some((element) => element === '0');
        if (unSubmitted) {
            return 'pending';
        }

        // En cours (priorité 3)
        const onGoing = statuses.some((element) => element === '1');
        if (onGoing) {
            return 'ongoing';
        }

        // Terminé (priorit²é 4) 2 = publié OK, 6 = soldé sans avis publié réussi
        const done = statuses.every((element) => ['2', '6'].includes(element));
        if (done) {
            return 'done';
        }

        return 'pending';
    };

    const status =
        category.id === CATEGORY_BODACC
            ? getArticleBodaccProcessesStatus(dossierArticles.map((da) => da.id))
            : getArticleProcessesStatus(
                  dossier,
                  category.validatorTypeId,
                  dossierArticles.map((a) => a.id),
              );

    const statusLabel = getArticleProcessesStatusLabel(status);

    const articleStatusToFlag = (sts: ArticleValidationProcessStatus): number => {
        const map: Record<string, number> = {
            done: 400,
            ongoing: 200,
            failed: 500,
            pending: 100,
            'to-link': 100,
        };
        return map[sts] ?? 100;
    };
    // label: string, statusFlag: number, statusLabel: string

    return (
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {category.label}
            {statusLabel && (
                <DossierArticleProcessStatus
                    statusFlag={articleStatusToFlag(status)}
                    statusLabel={statusLabel}
                />
            )}
        </Box>
    );
};

export default DossierProcessesTabTitle;
